/**
 * Cents-based time-digit input.
 *
 * The numpad collects raw digits; the right-most two are always hundredths.
 * Examples: "" → 0.00, "9" → 0.09, "20" → 0.20, "16789" → 167.89.
 */

export const MAX_TIME_DIGITS: number = 6;

export const formatCentsDigits = (digits: string): string => {
  if (digits.length === 0) return '0.00';
  const padded: string = digits.padStart(3, '0');
  const intPart: string = padded.slice(0, -2);
  const fracPart: string = padded.slice(-2);
  return `${Number.parseInt(intPart, 10)}.${fracPart}`;
};

export const centsDigitsToSeconds = (digits: string): number => {
  if (digits.length === 0) return 0;
  return Number.parseInt(digits, 10) / 100;
};
